/**
 * @generated SignedSource<<6528d80383297d7c881fda6da03668fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPageHeader_buyer$data = {
  readonly isTrade: boolean | null;
  readonly " $fragmentType": "CheckoutPageHeader_buyer";
};
export type CheckoutPageHeader_buyer$key = {
  readonly " $data"?: CheckoutPageHeader_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPageHeader_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPageHeader_buyer",
  "selections": [
    {
      "alias": "isTrade",
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4204c9002d7f8de9ef654aaa1cdb0883";

export default node;
